/**
 * GiftCardsLoadingState — the first-load spinner both gift-cards pages show
 * (BON-223). Shared rather than duplicated: list and detail want the exact
 * same treatment.
 */
import { Spinner } from '../dashboards/primitives';

export function GiftCardsLoadingState({ label }: { label: string }) {
  return (
    <div
      role="status"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0' }}
    >
      <Spinner size={22} />
      <span className="nb-sr-only">{label}</span>
    </div>
  );
}
